// Initialize before App imports: styled-components reads this global when it
// creates style tags. Reuse the response nonce already supplied to Emotion.
const nonce = document.querySelector<HTMLMetaElement>(
  'meta[name="csp-nonce"]'
)?.content;
if (nonce && nonce !== '__CSP_NONCE__') {
  (window as Window & { __webpack_nonce__?: string }).__webpack_nonce__ = nonce;
}

export {};
